import mockData from './mockMediaLibraryData.json'

let folders = [...mockData.folders]
let files = [...mockData.files]

export function getFolders() {
  return Promise.resolve([...folders])
}

export function getFiles(folderId) {
  // folderId === '-1' 时返回全部 files，否则返回指定文件夹下的 files
  if (String(folderId) === '-1') {
    return Promise.resolve([...files]);
  }
  return Promise.resolve(files.filter(f => String(f.folderId) === String(folderId)));
}

export function addFolder(name) {
  const id = (Math.max(...folders.map(f => Number(f.id)), 0) + 1).toString()
  const folder = { id, name, files: [] }
  folders.push(folder)
  return Promise.resolve(folder)
}

export function deleteFolder(id) {
  folders = folders.filter(f => f.id !== id)
  files = files.filter(f => f.folderId !== id)
  return Promise.resolve()
}

export function addFile(file) {
  if (!file.folderId) throw new Error("folderId is required");
  // 只添加到 files
  const newFile = { ...file, id: Date.now().toString() };
  files.push(newFile);
  // 可选：同步到 folder.files（不影响主流程，前端展示只依赖 files/getFiles）
  const folder = folders.find(f => String(f.id) === String(file.folderId));
  if (folder) {
    folder.files = folder.files || [];
    folder.files.push(newFile);
  }
  return Promise.resolve(newFile);
}

export function deleteFile(id) {
  // 从 files 删除
  files = files.filter(f => f.id !== id)
  // 从所有 folder.files 删除
  folders.forEach(folder => {
    if (folder.files) {
      folder.files = folder.files.filter(f => f.id !== id)
    }
  })
  return Promise.resolve()
}

export function updateFile(id, data) {
  // 更新 files
  files = files.map(f => f.id === id ? { ...f, ...data } : f)
  // 更新 folder.files
  folders.forEach(folder => {
    if (folder.files) {
      folder.files = folder.files.map(f => f.id === id ? { ...f, ...data } : f)
    }
  })
  return Promise.resolve(files.find(f => f.id === id))
}
